import { memo } from 'react';
import cls from 'classnames';

import cutShapesSVG from '@/assets/cutShapesSVG';
import { CutShapeId } from '@/product/entity/CutShape';

import styles from './ProductPlaceholder.module.css';

export const COLOR_DEFAULT = 'gray';
export const COLOR_OUTLINE_BROWN = 'outline-brown';
export const COLOR_OUTLINE_GREEN = 'outline-green';
export const COLOR_OUTLINE = 'outline';
export const COLOR_OUTLINE_WHITE = 'outline-white';

const DEFAULT_SHAPE = CutShapeId.Round;

const COLOR_CLASS_MAP: Record<string, string> = {
  [COLOR_OUTLINE]: styles.gemOutline,
  [COLOR_OUTLINE_BROWN]: styles.gemOutlineBrown,
  [COLOR_OUTLINE_GREEN]: styles.gemOutlineGreen,
  [COLOR_OUTLINE_WHITE]: styles.gemOutlineWhite,
};

interface ProductPlaceholderProps {
  shape?: Nullable<StringOrNumber>;
  color?: string;
  bold?: boolean;
  width?: Nullable<number>;
  height?: Nullable<number>;
}

function ProductPlaceholder(props: ProductPlaceholderProps) {
  const { shape = DEFAULT_SHAPE, color = COLOR_DEFAULT, bold = false, width = null, height = null } = props;

  const gemSVG = (shape !== null && cutShapesSVG[shape]) || cutShapesSVG[DEFAULT_SHAPE];

  return (
    <svg
      width={width ?? undefined}
      height={height ?? undefined}
      className={cls(styles.gem, COLOR_CLASS_MAP[color], { [styles.gemBold]: bold })}
      viewBox={gemSVG.viewBox}
      dangerouslySetInnerHTML={{ __html: gemSVG.body }}
    />
  );
}

export default memo(ProductPlaceholder);
